<template>
  <section id="experience" class="resume mb-3">
    <div class="resume-content mt-3">
      <!-- Experience -->
      <p class="headline__subtitle animate-headline">
        <svg xmlns="http://www.w3.org/2000/svg" width="13px" height="13px" viewBox="0 0 13 13" fill="currentColor">
          <path d="M5.6,12.6c-0.5-0.8-0.7-2.4-1.7-3.5c-1-1-2.7-1.2-3.5-1.7C-0.1,7-0.1,6,0.4,5.6c0.8-0.5,2.3-0.6,3.5-1.8
            C5,2.8,5.1,1.2,5.6,0.4C6-0.1,7-0.1,7.4,0.4c0.5,0.8,0.7,2.4,1.8,3.5c1.2,1.2,2.6,1.2,3.5,1.7c0.6,0.4,0.6,1.4,0,1.7
            C11.8,7.9,10.2,8,9.1,9.1c-1,1-1.2,2.7-1.7,3.5C7,13.1,6,13.1,5.6,12.6z" />
        </svg>
        <span>Experiences</span>
      </p>
      <div class="resume-items">
        <div class="resume-item" v-for="(item, index) in resumeItems" :key="index">
          <div class="item-header">
            <h5 class="title">{{ item.title }}</h5>
            <span class="year">{{ item.year }}</span>
          </div>
          <p style="color: #AD8330;"><strong>{{ item.place }}</strong></p>
          <ul class="desc-list">
            <li v-for="(desc, i) in item.description" :key="i">{{ desc }}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { resumeItems } from './data.js'

export default {
  name: 'ResumeSection',
  props: {
    tools: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      resumeItems: resumeItems
    };
  },
};
</script>

<style scoped>
.headline__subtitle {
  display: inline-flex;
  align-items: center;
  height: 3.4rem;
  padding: 0 1.4rem;
  border-radius: var(--_radius-s);
  border: 1px solid var(--stroke-elements);
  font: normal 700 18px/3.3rem var(--_font-default);
  margin-bottom: 1rem;
}

.resume-content {
  margin-top: 40px;
}

.resume-content p {
  font-size: 18px;
  position: relative;
  padding: 0 1.5rem;
}

.resume-items {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

@media (max-width: 768px) {
  .resume-items {
    margin-right: 10px;
  }
  .skill-icon {
    width: 48px;
    height: 48px;
    padding: 4px;
  }
}

.resume-item {
  text-align: left;
  padding: 15px;
  background: #f9f9f900;
  border-radius: var(--_radius-s);
  border: 2px solid rgba(176, 176, 176, 0.2);
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 5px;
  padding: 0 1.5rem;
}

.title {
  font-weight: bold;
  font-size: 18px;
  color: var(--t-bright--dark);
}

.year {
  font-size: 16px;
  color: #666;
}

.tools-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.tool-chip {
  background-color: #e0e0e0;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  transition: all 0.3s ease;
}

.tool-chip:hover {
  background-color: #ccc;
  color: #000;
}

.skill-section {
  margin-top: 60px;
}

.skill-title {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 20px;
}

.skill-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 40px;
  margin-right: 40px;
  margin-bottom: 40px;
}

.skill-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80px;
  text-align: center;
}

.skill-icon {
  width: 70px;
  height: 70px;
  object-fit: contain;
  margin-bottom: 8px;
  border: 2px solid #AD8330;
  border-radius: 12px;
  padding: 6px;
  box-sizing: border-box;
  transition: transform 0.2s ease;
}

.skill-name {
  font-size: 14px;
  color: #444;
}

.desc-list {
  padding-left: 2rem;
  margin-top: 0.5rem;
  color: var(--primary);
  font-size: 15px;
}

.desc-list li {
  margin-bottom: 0.5rem;
  line-height: 1.6;
  list-style: disc;
}
</style>
